// costCalculator.js

import { formatDecimal } from "./numberUtils.js";
export function calculateCosts(data) {
   
    // console.log(data.brakingHP);
    // console.log(data.pumpEfficiency);
    // console.log("default", data.defaultValues.irrigatedArea)
    // console.log("Current", data.irrigatedArea)
    //console.log(data)

    

    
    //-----------------Electricity------------------
    //total cost = 
    //    Total KWH*(Energy charge + Rider B + Rider G) +
    //    customer charge*213*(1+Rider J/100.) + 
    //    Demand charge*Kw*213 + 
    //    adminfee*7 - 
    //    rebate*total KWH
    data.electricityCost = formatDecimal(
        data.totalKWH * (data.energyCharge + data.riderB + data.riderG) +
        data.customerCharge * (1 + data.riderJ / 100.) * data.daysPerSeason +
        data.demandCharge * data.motorCapacity * data.daysPerSeason +
        data.adminFee * Math.round(data.daysPerSeason / 30.) -
        data.rebateProg * data.totalKWH, 2
    )
// console.log(data.totalKWH * (data.energyCharge + data.riderB + data.riderG))
// console.log(data.customerCharge * (1 + data.riderJ / 100.) * data.daysPerSeason)
// console.log(data.demandCharge * data.motorCapacity * data.daysPerSeason)
// console.log(data.adminFee * Math.round(data.daysPerSeason / 30.))
// console.log( data.rebateProg * data.totalKWH)
// console.log((data.energyCharge + data.riderB + data.riderG))
// console.log(typeof data.energyCharge)


    data.electricityCostPerAcre =  formatDecimal(data.electricityCost / data.irrigatedArea,2)
    data.electricityCostPerInch =  formatDecimal(data.electricityCost / data.grossInchesSeason,2)
    // console.log("electricityCostPerAcre",  data.electricityCostPerAcre)
    // console.log("electricityCostPerInch",  data.electricityCostPerInch)
    
    data.electricityCostPerAcreInch = formatDecimal(data.electricityCostPerInch/data.irrigatedArea,2)
    // console.log("hhhh",  data.electricityCostPerInch/data.irrigatedArea)

    // console.log("electricityCostPerAcreInch",  data.electricityCostPerAcreInch)
    data.electricityCostPerHpHr = formatDecimal(data.electricityCost / data.hoursPerSeason/data.brakingHP,2)
    data.electricityUsage = data.totalKWH
    data.electricityCostPerUnit = formatDecimal(data.electricityCost/data.electricityUsage,2)

    // Calculate natural gas costs
    // total cost =Total GJ *( NG Price+Rider L + variable deliery) + 
    //      fixed deliery*213+ 
    //      adminfee*7 - 
    //      total_GL*rebate

    data.ngCost = formatDecimal(
        data.ngTotalGJ * (data.ngGasPrice + data.ngRiderL + data.ngVariableDelivery) +
        data.ngFixedDelivery * data.daysPerSeason +
        data.ngAdminFee * Math.round(data.daysPerSeason / 30.) -
        data.ngRebateProg * data.ngTotalGJ, 2
    )
    data.ngCostPerAcre = formatDecimal(data.ngCost / data.irrigatedArea,2)
    data.ngCostPerInch = formatDecimal(data.ngCost / data.grossInchesSeason,2)
    data.ngCostPerAcreInch=formatDecimal(data.ngCostPerInch/data.irrigatedArea,2)
    data.ngCostPerHpHr = formatDecimal(data.ngCost / data.hoursPerSeason/data.brakingHP,2)
    data.ngUsage = data.ngTotalGJ
    data.ngCostPerUnit=formatDecimal(data.ngCost/data.ngUsage,2)

    //-----------------Diesel----------------------------
    // total cost = total Litres * Diesel Price - total Litres*rebate
    
    data.dieselCost = formatDecimal(data.dieselTotalLitre  * data.dieselPrice -
    data.dieselRebateProg * data.dieselTotalLitre, 2)
    data.dieselCostPerAcre = formatDecimal(data.dieselCost / data.irrigatedArea,2)
    data.dieselCostPerInch =formatDecimal(data.dieselCost / data.grossInchesSeason,2)
    data.dieselCostPerAcreInch = formatDecimal(data.dieselCostPerInch/data.irrigatedArea,2)
    data.dieselCostPerHpHr = formatDecimal(data.dieselCost / data.hoursPerSeason/data.brakingHP,2)
    data.dieselUsage = data.dieselTotalLitre
    data.dieselCostPerUnit = formatDecimal(data.dieselCost /data.dieselUsage,2)
    

    //-------------------Propane---------------------
    //total cost = total litres*price - total litres *rebate

    data.propaneCost = formatDecimal(data.propaneTotalConsumption * data.propanePrice -
        data.propaneRebate * data.propaneTotalConsumption, 2)
    data.propaneCostPerAcre = formatDecimal(data.propaneCost / data.irrigatedArea,2)
    data.propaneCostPerInch = formatDecimal(data.propaneCost / data.grossInchesSeason,2)
    data.propaneCostPerAcreInch=formatDecimal(data.propaneCostPerInch/data.irrigatedArea,2)
    data.propaneCostPerHpHr = formatDecimal(data.propaneCost / data.hoursPerSeason/data.brakingHP,2)
    data.propaneUsage = data.propaneTotalConsumption
    data.propaneCostPerUnit = formatDecimal(data.propaneCost/data.propaneUsage,2)

    // console.log("usage",data.propaneUsage)
    // console.log("cost", data.electricityCost)

}
